import { faTableLayout } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DropdownMenu } from '@nexelem/components';
import { useTableTranslation } from '../translations';
import { toggleColumnsOrderDrawer } from './ColumnsOrderDrawer';

export const ColumnsOrderButton = () => {
  const { t } = useTableTranslation();

  return (
    <DropdownMenu.Button StartIcon={<FontAwesomeIcon icon={faTableLayout} />} onClick={toggleColumnsOrderDrawer}>
      {t('columnsOrder')}
    </DropdownMenu.Button>
  );
};
